import { CountryCode, PropertyType } from '@ev-tech/search-modules-api';

export const EU_COUNTRY_CODES: ReadonlySet<CountryCode | string> = new Set([
  CountryCode.AT,
  CountryCode.BE,
  'BG',
  CountryCode.HR,
  'CY',
  CountryCode.CZ,
  CountryCode.DK,
  'EE',
  'FI',
  CountryCode.FR,
  CountryCode.DE,
  CountryCode.GR,
  CountryCode.HU,
  CountryCode.IE,
  CountryCode.IT,
  'LV',
  CountryCode.LU,
  'MT',
  CountryCode.NL,
  CountryCode.PT,
  'RO',
  'SK',
  'SI',
  CountryCode.ES,
  'SE',
]);

export function getEnergyCertificateTranslationKey(
  propertyType: PropertyType,
  country?: CountryCode | string,
  energyCertificateAvailable?: string,
): string {
  const showsEnergyCertAvailability = Boolean(propertyType !== PropertyType.land && country && EU_COUNTRY_CODES.has(country));

  if (energyCertificateAvailable === undefined) {
    return '';
  }

  if (energyCertificateAvailable === 'yes') {
    return 'search.listingData.label.yes';
  }

  if (energyCertificateAvailable === 'no' && showsEnergyCertAvailability) {
    return 'search.listingData.label.no';
  }

  if (energyCertificateAvailable === 'unknown' && showsEnergyCertAvailability) {
    return 'search.listingData.energy.value.energyCertificateAvailable.unknown';
  }

  return '';
}

export function normalizeEnergyTranslationItem({
  item,
  keyPrefix,
}: {
  item: string;
  keyPrefix: 'search.listingData.energy.heatingMaterial' | 'search.listingData.energy.heatingType';
}): string {
  if (keyPrefix.endsWith('heatingMaterial') && item.startsWith('heatingMaterial.')) {
    return item.replace('heatingMaterial.', '');
  }

  if (keyPrefix.endsWith('heatingType') && item.startsWith('heatingType.')) {
    return item.replace('heatingType.', '');
  }

  return item;
}
